jQuery($ => {
    function openInput($element) {
        $element.closest(".gfield").addClass("gfield--focused");
    }

    function maybeCloseInput($element) {
        if ($element.val() !== '') {
            $element
                .closest(".gfield")
                .addClass("gfield--focused")
                .removeAttr("style");
        } else {
            $element.closest(".gfield").removeClass("gfield--focused");
        }
    }

    if ($('.gfield input[type="text"], .gfield input[type="email"], .gfield textarea')[0]) {
        $(document).on('gform_post_render', function () {
            // Resize textareas surpassing the default lines
            $('.gfield textarea').each(function () {
                // autosize(this); // jshint ignore:line
            });

            var $inputs = $(".gfield input[type='text'], .gfield textarea, .gfield input[type='tel'], .gfield input[type='email'], .gfield input[type='url']");

            // If input has value, open it
            $inputs.each(function () {
                if ($(this).val() !== '') {
                    openInput($(this));
                }
            });

            // If input focused, open it
            $inputs.focus(function () {
                openInput($(this));
            });

            // If input blurred, close if has no value
            $inputs.blur(function () {
                maybeCloseInput($(this));
            });
        }).trigger('gform_post_render');
    }
});